<div>
  <div>
    <p>Changes you made may not be saved.</p>
    <p>Leave the page?</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button class="cancel-button" (click)="cancel()">
      Continue editing
    </button>
    <button mat-button class="leave-button" (click)="leave()">
      Leave editor
    </button>
  </div>
</div>
